import { render, staticRenderFns } from "./TransactionAuditLogs.vue?vue&type=template&id=8e8c8a6c&"
import script from "./TransactionAuditLogs.vue?vue&type=script&lang=js&"
export * from "./TransactionAuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./TransactionAuditLogs.vue?vue&type=style&index=0&id=8e8c8a6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports